'use client';

import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export default function FrontendObservability() {
  if (faro.api || typeof window === 'undefined') {
    return null;
  }

  try {
    initializeFaro({
      url: 'https://faro-collector-prod-gb-south-1.grafana.net/collect/3f1502b9444274d918eed7dc4f5949e9',
      app: {
        name: 'builder-home',
        namespace: 'tempcover',
        version: process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0',
        environment: process.env.NEXT_PUBLIC_APP_ENV || 'development',
      },

      instrumentations: [
        ...getWebInstrumentations({
          captureConsole: true,
        }),
        new TracingInstrumentation(),
      ],

      sessionTracking: {
        enabled: true,
      },
    });
  } catch (e) {
    console.error('Grafana Faro initialization failed:', e);
    return null;
  }
  return null;
}
